<template>
    <div class="container">
        <!-- 主内容区域 -->
        <main-content  ref="mainContent">  </main-content>
        <div class="deliver-container">
        <div class="deliver-btn2">
            <el-button size="mini" class="greybtn" style="width: 70px;" @click="goBack">返回</el-button>
        </div>
        <div class="deliver-btn">
            <el-button size="mini" class="bluebtn" @click="submitForm" style="width: 70px;">发布</el-button>
        </div>
        <h4 style="margin: 50px 0 10px 50px;text-align: left">新增商品</h4>
        <div class="table-box">
            <el-form :model="dataForm" :rules="dataRules" ref="dataForm" class="add-list-form" label-width="100px">
                <p class="cootitle">基础信息</p>
                <div class="overflow">
                    <div class="float-left div-css">
                        <el-form-item label="商品编码" prop="upc">
                            <el-input v-model="dataForm.upc" placeholder="不填，则自动生成"></el-input>
                        </el-form-item>
                        <el-form-item label="商品名称" prop="goodsName">
                            <el-input v-model="dataForm.goodsName" placeholder="请输入名称"></el-input>
                        </el-form-item>
                        <el-form-item label="商品分类" prop="category_id">
                            <el-select v-model="dataForm.category_id" placeholder="请选择商品分类" style="width: 100%">
                                <el-option
                                        v-for="item in goodsCate"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="商品现积分" prop="rewardNew">
                            <el-input v-model="dataForm.rewardNew" placeholder="0"></el-input>
                        </el-form-item>
                    </div>
                    <div class="float-left div-css div-css-left">
                        <el-form-item label="商品状态" prop="status">
                            <el-select v-model="dataForm.status" placeholder="请选择商品状态" style="width: 100%">
                                <el-option
                                        v-for="item in this.goodStatus"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="商品描述" prop="description">
                            <el-input v-model="dataForm.description" placeholder="请填写商品描述" style="width:100%"></el-input>
                        </el-form-item>
                        <el-form-item label="主题推荐" prop="theme_id">
                            <el-select v-model="dataForm.theme_id" placeholder="请选择主题推荐" style="width: 100%">
                                <el-option
                                        v-for="item in goodsTheme"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="商品原积分" prop="rewardOld">
                            <el-input v-model="dataForm.rewardOld" placeholder="0"></el-input>
                        </el-form-item>
                    </div>
                    <div class="float-left div-css div-css-left">
                        <el-form-item label="商品置顶" prop="recommend">
                            <el-radio-group v-model="dataForm.recommend">
                                <el-radio :label="1" :key="1" >置顶</el-radio>
                                <el-radio :label="0" :key="0">不置顶</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="绑定店铺" prop="shop_code">
                            <el-select v-model="dataForm.shop_code" placeholder="请绑定店铺" style="width: 100%">
                                <el-option
                                        v-for="item in goodsShop"
                                        :key="item.code"
                                        :label="item.name"
                                        :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="库存" prop="stock">
                            <el-input v-model="dataForm.stock" placeholder="0"></el-input>
                        </el-form-item>
                        <el-form-item label="已兑换数量" prop="exchange">
                            <el-input v-model="dataForm.exchange" placeholder="0"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <p class="cootitle">主图信息</p>
                <div class="overflow">
                    <div class="img-list">
                        <div class="left-title">主图</div>
                        <div class="right-imgs" style="z-index:999">
                            <div class="main-redtext">(标准图片大小 宽400px * 高400px)</div>
                            <div class="main-img">
                                <el-upload
                                        ref="upload_top"
                                        :action="uploadImage"
                                        :headers="headers"
                                        list-type="picture-card"
                                        :on-remove="handleRemove"
                                        :on-success="uploadSuccess"
                                        :file-list="fileListT"
                                        :on-change="handleChange"
                                        :class="mainFlag==true?'':'hide'">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="cootitle">商品轮播图</p>
                <div class="overflow">
                    <div class="img-list">
                        <div class="detail-img">
                            <label style="position: absolute;left: 0;top: 2px">上传图片</label>
                            <label style="position: absolute;left: 11%;top: 2px;color: red">(标准图片大小 宽750px * 高400px)</label>
                            <el-upload
                                    ref="upload1"
                                    :action="uploadImage"
                                    :headers="headers"
                                    list-type="picture-card"
                                    :on-remove="handleRemove1"
                                    :file-list="fileListB"
                                    :on-success="uploadSuccess1"
                                    multiple
                                    :limit="5"
                                    :on-change="handleChange1">
                                <div class="uploadBtn1">上传图片</div>
                            </el-upload>
                        </div>
                    </div>
                </div>

                <p class="cootitle">商品详情图</p>
                <div class="overflow">
                    <div class="img-list">
                        <div class="detail-img">
                            <label style="position: absolute;left: 0;top: 2px">上传图片</label>
                            <label style="position: absolute;left: 11%;top: 3px;color: red">(标准图片大小 宽750px * 高400px)</label>
                            <el-upload
                                    ref="upload"
                                    :action="uploadImage"
                                    list-type="picture-card"
                                    :headers="headers"
                                    :on-remove="handleRemove2"
                                    :on-success="uploadSuccess2"
                                    :file-list="fileListD"
                                    multiple
                                    :limit="5"
                                    :on-change="handleChange2">
                                <div class="uploadBtn1">上传图片</div>
                            </el-upload>
                        </div>
                    </div>
                </div>
            </el-form>
        </div>
    </div>
    </div>
</template>

<script>
    import MainContent from "../MainContent/MainContent"
import Cookies from "js-cookie"
export default {
    components: {
        MainContent
    },
    data(){
        return {
            goodStatus: [{
                id: 0,
                name: '待发布'
            },{
                id: 1,
                name: '已发布'
            },{
                id: 2,
                name: '已下架'
            }],
            goodsCate:[],
            goodsTheme: [],
            goodsShop: [],
            dataForm: {
                upc: '',
                category_id: '',
                theme_id: '',
                goodsName: '',
                description: '',
                shop_code: '',
                stock: 0,
                rewardNew: 0,
                exchange: 0,
                rewardOld: 0,
                top: 0,
                status : 0,
                top_img: '',
                detailUrl: [],
                proDetailUrl: [],

            },
            dataRules: {
                category_id: [
                    { required: true, message: '请选择分类', trigger: 'blur' }
                ],
                theme_id: [
                    { required: true, message: '请选择主题商品', trigger: 'blur' }
                ],
                goodsName: [
                    { required: true, message: '请选择商品名称', trigger: 'blur' }
                ],
                shop_code: [
                    { required: true, message: '请绑定店铺', trigger: 'blur' }
                ],
                stock: [
                    { required: true, message: '请填写库存', trigger: 'blur' }
                ],
                rewardNew: [
                    { required: true, message: '请填写商品现积分', trigger: 'blur' }
                ],
            },
            mainFlag: true,

            doMain:this.global.backDoMain,
            uploadImage:this.global.baseUrl + '/upload/image',
            fileListT: [],
            fileListB: [],
            fileListD: [],
        }
    },
    methods: {
        findPage() {
            this.loading = true;
            this.$api.category.findPageAll().then((res) => {
                this.goodsCate = res.data
            })
            this.$api.theme.findPageAll().then((res) => {
                this.goodsTheme = res.data
            })
            this.$api.shop.findPageAll().then((res) => {
                this.goodsShop = res.data
            })

        },
        //主图
        uploadSuccess(response) {
            console.log(response)
            if(response.code != 200) {
                this.$message({message: response.message, type: 'error'})
            }
            this.dataForm.top_img = response.data
        },
        handleChange(file, fileListT){
            console.log(fileListT)
            if(fileListT.length>0){
                this.mainFlag = false
            }else{
                this.mainFlag = true
            }
        },
        handleRemove(file, fileListT){
            this.dataForm.top_img = ''
            this.mainFlag = true
        },
        //详情轮播图
        uploadSuccess1(response) {
            if(response.code != 200) {
                this.$message({message: response.message, type: 'error'})
            }
            this.dataForm.detailUrl.push(response.data)
        },
        handleChange1(file, fileListB){
/*            if(fileListB.length>0){
                this.mainFlag = false
            }else{
                this.mainFlag = true
            }*/
        },
        handleRemove1(file, fileListB){
            var img = file.response.data
            this.dataForm.detailUrl.forEach((element,index) =>{
                if (img == element) {
                    this.dataForm.detailUrl.splice(index,1)
                }
            })
        },
        //详情图
        uploadSuccess2(response) {
            console.log(response)
            if(response.code != 200) {
                this.$message({message: response.message, type: 'error'})
            }
            this.dataForm.proDetailUrl.push(response.data)
        },
        handleChange2(file, fileListD){
/*            if(fileListD.length>0){
                this.mainFlag = false
            }else{
                this.mainFlag = true
            }*/
        },
        handleRemove2(file, fileListD){
            var img = file.response.data
            this.dataForm.proDetailUrl.forEach((element,index) =>{
                if (img == element) {
                    this.dataForm.proDetailUrl.splice(index,1)
                }
            })
        },
        submitForm: function () {
            this.$refs.dataForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认提交吗？', '提示', {}).then(() => {
                        let params = Object.assign({}, this.dataForm)
                        this.$api.goods.add(params).then((res) => {
                            if(res.code == 200) {
                                this.$message({ message: '发布成功', type: 'success' })
                                this.$router.go(-1);
                                this.$refs.mainContent.tabsCloseCurrentHandle();
                            } else if (res.code == 302) {
                                this.$message({
                                    message: res.message,
                                    type: "error"
                                });
                            } else {
                                this.$message({message: res.message, type: 'error'})
                            }
                        })
                    })
                }
            })
        },
        goBack() {
            this.$router.go(-1);
            this.$refs.mainContent.tabsCloseCurrentHandle();
        }
    },
    mounted() {
        this.findPage()
    },
    computed: {
        headers() {
            return{
                "Authorization": Cookies.get('token') // 直接从本地获取token就行
            }
        }
    },
}
</script>

<style lang="scss">
@import "../../assets/base/deliver.css";
.main-img {
    text-align: left;
    .el-upload--picture-card{
        width: 100px;
        height: 100px;
        line-height: 98px;
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
    }
    .el-upload-list--picture-card .el-upload-list__item{
        width: 100px;
        height: 100px;
    }
}
.hide .el-upload--picture-card {
  display: none;
}
// 详情轮播图和商品详情图
.detail-img{
    position: relative;
    width: 95%;
    padding-top: 40px;
    margin-left: 4%;
    text-align: left;
    .el-upload--picture-card{
        background-color: transparent;
        border: none;
        position: absolute;
        left: 0;
        top: 0;
    }
    .el-upload-list--picture-card .el-upload-list__item{
        width: 225px;
        height: 120px;
    }
}

</style>
<style lang="scss" scoped>
.deliver-container{
    padding: 0 20px 20px 20px;
}
.wrap{
    padding-top: 20px;
    padding-right: 40px;
    .el-select{
        width: 100%;
    }
}
.deliver-btn{
    text-align: right;
    position: fixed;
    right: 20px;
    top: 70px;
    z-index: 999;
}
.deliver-btn2{
    position: fixed;
    left: 190px;
    top: 70px;
    z-index: 999;
}
.cootitle {
    height: 20px;
    line-height: 20px;
    border-bottom: 1px solid #ccc;
    font-size: 14px;
    margin-bottom: 10px;
}
.add-list-form {
    margin: 0 65px 20px 75px;
}
.div-css{
    width: 24%;
}
.div-css-left{
    margin-left: 12.5%;
}
.main-redtext{
    color: red;
    text-align: left;
    padding: 8px 0;
    font-size: 12px;
}
.img-list{
    display: flex;
    font-size: 12px;
    margin-bottom: 30px;
    .left-title{
        width: 100px;
        text-align: right;
        padding-top: 8px;
        padding-right: 10px;

    }
    .uploadBtn1{
        margin-left: 40%;
        background-color: #669933;
        color: #fff;
        width: 80px;
        height: 24px;
        line-height: 24px;
        border-radius: 2px;
        cursor: pointer;
        font-size: 12px;
    }
}

</style>


// WEBPACK FOOTER //
// src/views/Goods/Deliver.vue